
import http from '@/components/services/http-common';
import DataFilter from '@/components/DataFilter';
import ExportExcel from '@/components/ExportExcel';
import CreateDialog from '../HrCreate.vue';
import CreateDialogPersonal from '../CreatePersonal.vue';
import * as moment from "moment/moment"

export default {
    name: "Attendance",
    components: {
        'data-filter': DataFilter,
        'create-dialog': CreateDialog,
        'export-excel': ExportExcel,
        'create-dialog-personal': CreateDialogPersonal

    },
    props: ["breadcrumbs", "icon"],
    watch: {
        dialog(val) {
            if (!this.dialog)
                this.item = null;
        },
        tableParams: {
            handler(val) {
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler(val) {
                this.tableParams.page = 1;
                this.fetchData();
            },
            deep: true,
        },
        month(val) {
            this.fetchData();
        }

    },
    computed: {
        params: function () {
            return { ...this.tableParams, ...this.filters }
        },
        filteredItems() {
            let result = this.items;
            if (this.departmentSearch) {
                let lowerSearch = this.departmentSearch.toLowerCase();
                result = result.filter(item => item.departmentName && item.departmentName.toLowerCase().includes(lowerSearch));
            }
            return result;
        },
        totalCount() { return this.filteredItems.length; },
        departments() {
            const depts = this.items.map(item => item.departmentName).filter(name => !!name);
            return [...new Set(depts)].sort();
        },
        pendingCount() { return this.filteredItems.filter(item => item.hrAccept == 0).length; },
        confirmedCount() { return this.filteredItems.filter(item => item.hrAccept == 1).length; },
        rejectedCount() { return this.filteredItems.filter(item => item.hrAccept == 4).length; }
    },
    data() {
        return {
            ROOT_URL: "quitRequests/",
            exportPrompt: false,
            month: moment().format("YYYY-MM"),
            //filter
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
            },
            filters: {
                code: null,
                employeeCode: null,
                employeeName: null,
                deparmentCode: null,
                shiftCode: null,
            },
            isFocused: false,
            departmentSearch: null,
            shifts: [],
            rowCount: 0,

            filter: {
                menu: false,
                search: "",
                searchAttr: "name",
                searchAttrs: undefined,
                FilterAttrs: [],
                FilterOn: ["DepartmentTypeCode"],

                from: undefined,
                to: undefined,
                fromOns: [
                ],
                fromOn: "",
            },

            // VIEW DATA
            filterOpen: 1,

            //DATA TABLE
            totalItem: 0,
            items: [],
            search: "",
            options: {},
            isLoading: true,

            createDialog: false,
            dialog: false, item: null,
            dialogDelete: false,
            targetItem: undefined,

            viewImageDialog: false,
            currentImageUrl: '',

            dialogConfirm: false,
            confirmNote: '',
            confirmFile: null,
            confirmFileUrl: '',

            globalSearch: '',
            headers: [
                { text: 'Thao tác', value: 'actions', width: '6rem' },
                { text: 'Mã', align: 'start', value: 'code', width: '4rem' },
                { text: 'Loại', align: 'start', value: 'quitTypeName', width: '6rem' },
                { text: '', align: ' d-none', value: 'quitEmployeeCode' },
                { text: 'Nhân viên', align: 'start', value: 'employeeInfo', width: '13rem' },
                { text: 'Thời gian', align: 'start', value: 'durationInfo', width: '11rem' },
                { text: 'Lý do', align: 'start', value: 'quitReason', width: '10rem' },
                { text: 'Tiến trình duyệt', align: 'start', value: 'acceptBy1', width: '16rem' },
                { text: 'HR', align: 'center', value: 'acceptBy3', width: '6rem' },
                { text: 'Đính kèm', align: 'center', value: 'attachment', width: '5rem', sortable: false },
                { text: 'Ngày gởi', align: 'start', value: 'sendDate', width: '6rem' },
            ],
            dialogDeny: false,
            denyNote: "",
        }
    },
    methods: {
        formatTime(value) {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        },
        viewImage(url) {
            this.currentImageUrl = url;
            this.viewImageDialog = true;
        },
        fetchData() {
            return http.get(this.ROOT_URL + "hr", {
                params: {
                    month: this.month,
                }
            })
                .then(res => {
                    this.items = res.data.data;
                    this.isLoading = false;
                });
        },

        checkAndOpenConfirm(item) {
            if (item.acceptBy2) {
                if (item.l2Accept == 0) {
                    if (!confirm("Quản lý trực tiếp chưa duyệt bạn có muốn tiếp tục")) return;
                } else if (item.l2Accept == 4) {
                    if (!confirm("Quản lý trực tiếp từ chối bạn có muốn tiếp tục")) return;
                }
            }
            this.targetItem = item;
            this.dialogConfirm = true;
        },

        checkAndOpenDeny(item) {
            if (item.acceptBy2) {
                if (item.l2Accept == 0) {
                    if (!confirm("Quản lý trực tiếp chưa duyệt bạn có muốn tiếp tục")) return;
                } else if (item.l2Accept == 4) {
                    if (!confirm("Quản lý trực tiếp từ chối bạn có muốn tiếp tục")) return;
                }
            }
            this.targetItem = item;
            this.dialogDeny = true;
        },

        uploadConfirmFile(file) {
            if (!file) {
                this.confirmFileUrl = '';
                return;
            }
            let formData = new FormData();
            formData.append('file', file);
            http.post("NasUploads?folder=QuitRequest", formData).then(res => {
                this.confirmFileUrl = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
            });
        },

        confirm() {
            if (this.targetItem == undefined) return;

            let params = { note: this.confirmNote };
            if (this.confirmFileUrl) {
                params.attachment = this.confirmFileUrl;
            }

            return http.get(this.ROOT_URL + "hr/accept/" + this.targetItem.code, { params }).then(() => {
                this.$emit("fetch");
                this.dialogConfirm = false;
                this.confirmNote = '';
                this.confirmFile = null;
                this.confirmFileUrl = '';
            }).finally(() => {
                this.fetchData();
            });
        },

        deny() {
            if (this.targetItem == undefined) return;

            return http.get(this.ROOT_URL + "hr/deny/" + this.targetItem.code, { params: { note: this.denyNote } }).then(() => {
                this.$emit("fetch");
                this.dialogDeny = false;
                this.denyNote = '';
            }).finally(() => {
                this.fetchData();
            });
        },

        edit(item) {
            this.item = item;
            this.dialog = true;
        },

        remove(item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            return http.delete(this.ROOT_URL + "hr/" + this.targetItem.code).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            })
        },
    },
    created() {
        this.fetchData();
    },

}